<template>
    <video ref="videoPlayer" class="video-js"></video>
</template>

<script>
import videojs from 'video.js';
import 'video.js/dist/video-js.min.css';

export default {
    name: "VideoPlayer",
    data() {
        return {
            player: null,
            options: {
                id: 'video-stream',
                autoplay: true,
                liveui: true,
                controls: true,
                userActions: {
                    hotkeys: {
                      // eslint-disable-next-line no-unused-vars
                        playPauseKey: function(event) {
                            return false;
                        }
                    },
                },
                controlBar: {
                  playToggle: false,
                  captionsButton: false,
                  chaptersButton: false,
                  subtitlesButton: false,
                  remainingTimeDisplay: false,
                  progressControl: {
                    seekBar: true
                  },
                  fullscreenToggle: false,
                  playbackRateMenuButton: false,
                },
            },
        }
    },
    mounted() {
        this.player = videojs(this.$refs.videoPlayer, this.options)

        let ref = this;
        this.player.on('click', function() {
            // todo: on mobile this works only if you click on active toolbar of the video
            // to handle switch with map functionality
            ref.$emit('videoclicked');
        });

        // temporary solution to prevent mouse click from pausing the video stream https://github.com/videojs/video.js/issues/2444
        // overriding handleTechClick_ does not work for some reason, even setting mouseup event again does not work
        // this.on(this.tech_, 'mouseup', this.handleTechClick_);
        this.player.pause = function() {}

        // emit player ready event with reference to video player html element
        this.$emit('onPlayerReady', this.player.tech().el())
    },
    beforeDestroy() {
        if (this.player) {
            this.player.dispose()
        }
    },
}
</script>

<style>
video {
  width: 100%;
  height: 100%;
}

.video-js .vjs-big-play-button {
  display: none;
}

</style>
